<template>
    <v-dialog
            v-model="dialog"
            width="600">
        <template v-slot:activator="{on}">
            <v-btn color="primary" v-on="on">추가</v-btn>
        </template>
        <v-card>
            <v-card-title>그룹 권한 추가</v-card-title>
            <v-card-text>
                <v-text-field v-model="editContext.code" label="그룹 코드" placeholder="20자 이내로 작성하시오" :rules="codeRule"></v-text-field>
                <v-text-field v-model="editContext.name" label="그룹 이름"></v-text-field>
            </v-card-text>
            <v-card-actions class="justify-space-between">
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="dialog = false">Cancel</v-btn>
                <v-btn color="primary" text @click="onClickSave" :disabled="!valid">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {PATH} from "@/constants";
    import {ON_SYSTEM_PERMISSION_GROUP_RECEIVED} from "@/framework/listeners/listeners";

    export default {
        name: "SystemPermissionGroupCreateButton",
        props: {
            type: {
                type: String,
                default: undefined,
            }
        },
        data() {
            return {
                dialog: false,
                editContext: {
                    code: "",
                    name: "",
                },
                codeRule: [
                    (v) => !!v && v.length < 20 && !!/^[A-Z_]+[A-Z]$/.exec(v) || "그룹 코드는 알파벳과 _(언더바)만 포함할 수 있습니다."
                ],
            };
        },
        watch: {
            'editContext.code'() {
                this.editContext.code = this.editContext.code.trim().toUpperCase();
            },
            'editContext.name'() {
                this.editContext.name = this.editContext.name.trim();
            },
        },
        computed: {
            valid() {
                for (let i = 0; i < this.codeRule.length; i++) {
                    if (this.codeRule[i](this.editContext.code) !== true) return false;
                }
                return true;
            },

            uriComputed() {
                if (this.type === 'SYSTEM') {
                    return PATH.SYSTEM_PERMISSION_GROUP.CREATE_BY_SYSTEM;
                } else if (this.type === 'RENTALCOMPANY') {
                    return PATH.SYSTEM_PERMISSION_GROUP.CREATE_BY_RENTALCOMPANY;
                }

                return undefined;
            },
        },
        methods: {
            onClickSave() {
                this.$requestWithOverlay(this.uriComputed)
                    .setObject(this.editContext)
                    .enqueue()
                    .then(() => {
                        this.$alert("권한 그룹이 추가되었습니다.");
                        this.editContext = { code: "", name: "", };
                        this.dialog = false;
                        this.notifyEvent(ON_SYSTEM_PERMISSION_GROUP_RECEIVED);
                    });
            }
        }
    }
</script>

<style scoped>

</style>